import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import { Card, CardBody, CardHeader } from 'reactstrap';
import Header from 'components/Header/index';
import FormDiario from 'app/routes/diario/form';
import GradeDiario from 'app/routes/diario/grade';
import { iniciaDiario, hideMessage, buscaDiario } from 'actions/Diario';
import { selecionaModulos, fechaModulos, ativaTestes } from 'actions/Auth';
import { irParaModulo } from 'actions/Setting';
import AlternaModulos from 'components/AlternaModulos';
import IntlMessages from 'util/IntlMessages';

const styles = theme => ({
    cardWrapper: {
        display: "flex",
        justifyContent: "center",
        width: "100%",
        height: "100%",
        overflowY: "auto"
    },

    contentContainer: {
        width: "100%",
        maxWidth: 1200,
        margin: "0 auto",
        padding: theme.spacing(2),
        minHeight: "100%",
        [theme.breakpoints.up("lg")]: {
            maxWidth: 1400,
        }
    },

    cardHeader: {
        backgroundColor: "#FFFFFF",
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
    },

    card: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100%",
        border: "1px solid #F4F4F7",
        borderRadius: 15,
        width: "100%",
        backgroundColor: "#FFFFFF",
    },

    cardBody: {
        flex: 1,
        padding: 16,
        overflowY: "auto"
    }
});

class DiarioModule extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstLoad: true
        };
    }

    componentDidMount() {
        if (this.props.iniciaDiario) {
            this.props.iniciaDiario();
        }

        if (this.props.buscaDiario) {
            this.props.buscaDiario({});
        }
    }

    componentDidUpdate(prevProps) {
        if (
            this.state.firstLoad &&
            (
                this.props.exibirDiario ||
                (!this.props.loader && !this.props.buscando && prevProps.loader)
            )
        ) {
            this.setState({ firstLoad: false });
        }
    }

    render() {
        const {
            classes,
            exibirDiario,
            loader,
            alertMessage,
            showMessageSuccess,
            showMessageError,
            hideMessage,
            selecionaModulo,
            loginRecente,
            fechaModulos
        } = this.props;

        const { firstLoad } = this.state;

        if (selecionaModulo) {
            return (
                <div className="app-main-container">
                    <div className="app-header">
                        <Header {...this.props} />
                    </div>

                    <main className="app-main-content-wrapper">
                        <div className="app-main-content" style={{ marginTop: 24 }}>
                            <AlternaModulos
                                {...this.props}
                                exibeFechar={!loginRecente}
                                funcaoFechar={() => fechaModulos()}
                            />
                        </div>
                    </main>
                </div>
            );
        }

        const titulo = exibirDiario
            ? <IntlMessages id="diario.grade.titulo" defaultMessage="Diário" />
            : <IntlMessages id="diario.pagina.titulo" defaultMessage="Diário Escolar" />;

        const showGrade = exibirDiario;
        const showForm = !exibirDiario && !firstLoad && !loader && !this.props.buscando;
        const showInitialLoader = firstLoad && (loader || this.props.buscando);

        return (
            <div className={classes.cardWrapper}>
                <div className={classes.contentContainer}>

                    <Card className={`shadow border-0 ${classes.card}`}>

                        <CardBody className={classes.cardBody}>

                            {showGrade && (
                                <GradeDiario
                                    standalone={true}
                                    onVoltarStandalone={() => this.props.selecionaModulos(true)}
                                />
                            )}

                            {showForm && <FormDiario />}

                            {showInitialLoader && (
                                <div
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        height: '100%',
                                        flexDirection: 'column'
                                    }}
                                >
                                    <div className="loader" style={{ marginBottom: 20 }}></div>

                                    <p
                                        style={{
                                            fontFamily: 'Montserrat',
                                            color: '#666'
                                        }}
                                    >
                                        Carregando diário...
                                    </p>
                                </div>
                            )}

                        </CardBody>

                    </Card>

                </div>
            </div>
        );
    }
}

DiarioModule.propTypes = {
    classes: PropTypes.object.isRequired,
};

const mapStateToProps = ({ diario, auth, settings }) => {

    const {
        loader,
        alertMessage,
        showMessageSuccess,
        showMessageError,
        exibirDiario,
        buscando
    } = diario || {};

    const {
        selecionarModulo,
        perfil,
        acessaPortaria,
        acessaBackOffice
    } = auth || {};

    const {
        loginRecente,
        configuracao,
        navigationStyle,
        horizontalNavPosition,
        moduloSelecionado,
        locale
    } = settings || {};

    return {
        loader,
        alertMessage,
        showMessageSuccess,
        showMessageError,
        exibirDiario,
        buscando,

        selecionaModulo: selecionarModulo,
        loginRecente,
        configuracao,

        navigationStyle,
        horizontalNavPosition,
        moduloSelecionado,
        locale,

        perfil,
        acessaPortaria,
        acessaBackOffice
    };
};

export default withRouter(
    connect(mapStateToProps, {
        iniciaDiario,
        hideMessage,
        buscaDiario,
        selecionaModulos,
        fechaModulos,
        ativaTestes,
        irParaModulo
    })(withStyles(styles)(DiarioModule))
);